enum ProductType {
  'SPARK_10' = 1,
  'SPARK_20' = 2,
  'SPARK_ADVANCED' = 3,
  'IDB' = 4,
}

export { ProductType }
